module.exports = __webpack_public_path__ + "static/media/50Mbps.5c303fa6.bin";